

















































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
@Component({})
export default class CdOrder extends Vue {
  public carList: Array<{
    beginTime: "string";
    endTime: "string";
    mobile: "string";
    orderNo: "string";
    orderStatus: "string";
    stationName: "string";
    totalAmount: 0;
    totalElec: 0;
    userName: "string";
  }> = [];
  public carNo = null;
  public loading = false;
  public OrderTime = [];
  //   初始化 表格行
  tableRowClassName({ row, rowIndex }: any) {
    if (rowIndex % 2 == 0) {
      return "warning-row second-class";
    } else {
      return "";
    }
  }
  //start 分页
  public total = 0;
  public currentPage = 1;
  public listParam = {
    pageIndex: 1,
    pageSize: 10,
    orderNo: "",
    mobile: "",
    beginTime: "",
    endTime: ""
  };
  public orderDetailParam = {};
  mounted() {
    this.getlistData();
  }

  getlistData() {
    if (this.OrderTime != null &&this.OrderTime.length!=0) {
      this.listParam.beginTime = moment(this.OrderTime[0]).format("YYYY-MM-DD");
      this.listParam.endTime = moment(this.OrderTime[1]).format("YYYY-MM-DD");
    } else {
      this.listParam.beginTime = "";
      this.listParam.endTime = "";
    }

    axios.get("orderlist", { params: this.listParam }).then(res => {
      if (res.data.errCode == 0) {
        this.carList = res.data.result;
        this.total = res.data.totalCount;
      }
    });
  }
  handleSizeChange(val: any) {
    console.log(`size${val}`);
    this.listParam.pageSize = val;
    this.getlistData();
  }
  //   只要分页发生改变  此函数就会被调用
  handleCurrentChange(val: any) {
    console.log(`current${val}`);
    this.listParam.pageIndex = val;
    this.getlistData();
  }
  handlePrev(val: any) {
    console.log(`prev${val}`);
  }
  handleNext(val: any) {
    console.log(`next${val}`);
  }
  //   end 分页

  //start 弹框
  public orderDialog = false;

  orderDetail(val: any) {
    this.loading = true;
    this.orderDetailParam = {};
    axios.get("order", { params: { orderNo: val } }).then(res => {
      if (res.data.errCode == 0) {
        this.loading = false;
        this.orderDetailParam = res.data.result;
      }
    });
  }
  // end 弹框
}
